import styled from 'styled-components';
import { space, layout, border } from 'styled-system';

const Divider = styled.hr`
  ${space};
  ${layout};
  ${border};
`;

Divider.defaultProps = {
  border: 0,
  borderBottom: '1px solid',
  borderColor: 'greyLight',
};

export default Divider;
